import { useEffect, useState } from 'react'
import { BaseRoute, generalRouter, Loading } from 'Components'
import { notification } from 'antd'
import changelog from 'Dummy/changelog'
import WeaverService from 'Services/WeaverService'
import { setCurrentProject } from 'Actions/projects'
import { Switch, Route, withRouter, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useQuery } from 'Hooks'
import { setCurrentItem, setTab, setTabDisabled, } from 'Actions/explore'
import { setIsMonteur } from 'Actions/user'
import { Branches, Compare, CommitTree, Dashboard, MergeRequests, Settings, Pipelines, Explore } from 'Pages'
import { splitUid, getUid } from 'Services/WeaverUtils'
import { QUERY, ATTRIBUTES } from 'Types'
import { GraphView } from 'Model'

Main = ({ setCurrentItem, setIsMonteur, darkModeEnabled, authToken, currentProject, setCurrentProject, match, setTab, setTabDisabled }) ->

  defaultTitle = 'Weaver - The user-friendly way to structure your information'
  [loading, setLoading] = useState(true)
  [title, setTitle] = useState(defaultTitle)

  params = useQuery()
  history = useHistory()
  { url } = useRouteMatch()
  { hash }  = useLocation()

  useEffect(->
    (->
      if currentProject?
        setTitle((await Weaver.Project.load(currentProject)).name())
      else
        setTitle(defaultTitle)
    )()
    undefined
  , [currentProject])

  useEffect(->
    (->
      user = Weaver.getInstance().currentUser()
      userRoles = await user.getRoles()
      userIsMonteur = userRoles.find((role) -> role.name() is 'Monteur') isnt undefined
      setIsMonteur(userIsMonteur)
      if userIsMonteur and url isnt '/'
        history.replace(url + '/dashboard/overview')
    )()
    undefined
  ,[])

  { path, params: { spaceId }} = match

  showNoProjectFeedback = (id) ->
    return unless id
    notification.error({
        message: 404
        duration: 5
        description: "Couldn't find a space with id #{ id }."
      })

  loadProject = (id) ->
    if WeaverService.isAuthenticated()
      availableProjectIds = (await Weaver.getInstance().currentUser().getProjects()).map((project) -> project.id())
      if id in availableProjectIds
        Weaver.Project.load(id)
      else
        showNoProjectFeedback(id)
        getFirstProject()
    else
      try
        await Weaver.Project.load(id)
      catch
        await getFirstProject()

  getFirstProject = ->
    if WeaverService.isAuthenticated()
      _.sortBy((await Weaver.getInstance().currentUser().getProjects()), (p) -> p.name())[0]
    else
      _.sortBy((await Weaver.Project.list()), (p) -> p.name())[0]

  showElementInGraph = (id) ->
    [id, graph] = splitUid(id)
    try
      query = new Weaver.Query()
        .restrict(id)
        .inGraph(graph)
        .selectOut('*')
        .selectIn('*')

      id = getUid(await query.first())

      setCurrentItem({
        type: QUERY
        data: { query }
      })
      setTimeout(->
        setCurrentItem({
          type: ATTRIBUTES
          id
        })
        params.set('tab', 'attributes')
        history.replace({ pathname: url, search: params.toString(), hash })
        setTab('attributes')
      , 0)
    catch
      setLoading(false)

  openDefaultView = (defaultView) ->
    if defaultView.get('treeQuery')?
      treeQuery = new Weaver.QueryBuilder(defaultView.get('treeQuery')).build()
      query = new Weaver.QueryBuilder(defaultView.get('query')).build()
    else
      query = new Weaver.QueryBuilder(defaultView.get('query')).build()

    setTimeout(->
      setCurrentItem({
        data: { treeQuery, query }
        id: defaultView.id()
        type: defaultView.get('type')
      })
      setTabDisabled({ key: 'elements', disabled: false })
    , 0)

  useEffect(->
    (->
      setTab('home')
      return setLoading(false) if spaceId? and WeaverService.currentProject()?.id() is spaceId
      params.set('tab', 'home')
      history.replace({ pathname: url, search: params.toString(), hash })
      setLoading(true)
      project = await loadProject(spaceId or currentProject)

      if project?
        await WeaverService.setProject(project)
        if spaceId isnt project.id()
          history.replace("/#{project.id()}")
      else if not WeaverService.isAuthenticated()
        history.replace('/login')
      else
        setCurrentProject(undefined)
        setLoading(false)
        return

      if id = location.hash.substr(1) or params.get('id')
        showElementInGraph(id)
      else if defaultView = await GraphView.getOpenDefault()
        openDefaultView(defaultView)
      setLoading(false)
    )()
    undefined
  [spaceId])

  if loading
    <Loading />
  else
    <>
      <Helmet><title>{ title }</title></Helmet>
      <Switch>
        <BaseRoute path="#{path}/settings"><Settings /></BaseRoute>
        <BaseRoute path="#{path}/merge-requests"><MergeRequests /></BaseRoute>
        <BaseRoute path="#{path}/commit-tree"><CommitTree /></BaseRoute>
        <BaseRoute path="#{path}/compare"><Compare /></BaseRoute>
        <BaseRoute path="#{path}/dashboard"><Dashboard /></BaseRoute>
        <BaseRoute path="#{path}/branches"><Branches /></BaseRoute>
        <BaseRoute path="#{path}/pipelines"><Pipelines /></BaseRoute>
        <Route exact><Explore /></Route>
      </Switch>
    </>

export default withRouter(connect(({ explore: { darkModeEnabled }, user: { authToken }, projects: { currentProject }}) ->
  { darkModeEnabled, currentProject, authToken }
, { setTabDisabled, setCurrentItem, setTab, setCurrentProject, setIsMonteur }
)(Main))
